<template>
  <div>
    <van-popup v-model="value" style="width: 80vw;" duration="0.1" @click-overlay="close">
      <div class="gift-body">
        <div class="gift-title">
          盲盒中奖礼品
          <img src="/static/images/default/x.png" class="gift-title-img" @click="close">
        </div>
        <div class="gift-content">
          <div class="gift-box" v-for="(item,index) in winningGiftList" :key="index">
            <div class="gift-img" @click="clickGiftsEvent(item)">
              <img :src="item.imgUrl">
              <div class="watch" v-if="item.svgaUrl" >
                  <span>特效</span>
              </div>
            </div>
            <div class="name">{{ item.name }} x {{item.num}}</div>
            <div class="price"></div>
          </div>
        </div>
      </div>
    </van-popup>
  </div>

</template>

<script>
import Vue from 'vue';
import { Icon, Popup} from "vant";

Vue.use(Icon);
Vue.use(Popup);
export default {
  name: "blind-box-gifts",
  components: {
  },
  props: {
  },
  data (){
    return {
      value:false,
      winningGiftList:[]
    }
  },
  watch:{
  },
  computed: {
  },
  methods: {
    show(winningGiftList) {
      this.value = true
      this.winningGiftList = winningGiftList
    },
    watchReward(svgaUrl){
      this.$refs.child.specialEffects(svgaUrl);
    },
    clickGiftsEvent(item) {
      if (item.svgaUrl)
        this.$emit('watchReward',item.svgaUrl);
    },
    close(){
      this.value=false
    }
  },
  activated() {
  },
  mounted() {
  }
}
</script>

<style lang="less" scoped>
/deep/ .van-popup {
  background: none;
}

.gift-body {
  background: rgba(255, 255, 255, 0.1);
  border: 1px solid rgba(255, 255, 255, 0.7);
  border-radius: 10px;

  .gift-title {
    margin-top: 10px;
    display: flex;
    position: relative;
    justify-content: center;
    color: #FFFFFF;
    font-size: 15px;
    font-weight: bold;

    .gift-title-img {
      height: 22px;
      width: 22px;
      text-align: center;
      position: absolute;
      right: 8px
    }
  }

  .gift-content {
    display: flex;
    flex-flow: row wrap;
    padding: 18px 9px;
    overflow: hidden;

    .gift-box {
      width: calc(33.33% - 14px * 2);
      display: flex;
      flex-flow: column;
      align-items: center;
      margin: 0 14px;

      .gift-img {
        width: 100%;
        padding-top: 100%;
        position: relative;

        .watch {
          position: absolute;
          right: -5px;
          top: -5px;
          font-size: 9px;
          background: var(--primary-color);
          color: white;
          padding: 1px 3px;
          border-radius: 10px;
        }

        img {
          display: block;
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          width: 100%;
          height: 100%;
          object-fit: cover;
        }
      }

      .name {
        color: #fff;
        font-size: 13px;
        margin-top: 3px;
      }

      .price {
        color: rgba(255, 255, 255, 0.3);
        font-size: 11px;
        margin: 9px 0 13px 0;
      }
    }
  }

}


</style>
